import '../bootstrap.js';
import { createApp } from 'vue/dist/vue.esm-bundler';
import filters from "../shared/filters/filters";
import Topics from "./Topics.vue";

const app = createApp({
    mounted() {
        $("#keywordLoading").hide();
    }
});
app.config.globalProperties.$_f = filters;
app.component('topics', Topics);
app.mount("#user-app")

